const $ = require('jquery');
require('featherlight');
require('featherlight-gallery');

$.featherlight.prototype.variant = 'featherlight--base';
$.featherlightGallery.prototype.variant = 'featherlight--gallery';
